const color = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "neutral"
] as const

const size = [
  "3xs",
  "2xs",
  "xs",
  "sm",
  "md",
  "lg",
  "xl",
  "2xl",
  "3xl"
] as const

const position = [
  "top-right",
  "bottom-right",
  "top-left",
  "bottom-left"
] as const

export default {
  "slots": {
    "root": "tw:relative tw:inline-flex tw:items-center tw:justify-center tw:shrink-0",
    "base": "tw:rounded-full tw:ring tw:ring-bg tw:flex tw:items-center tw:justify-center tw:text-inverted tw:font-medium tw:whitespace-nowrap"
  },
  "variants": {
    "color": {
      "primary": "tw:bg-primary",
      "secondary": "tw:bg-secondary",
      "success": "tw:bg-success",
      "info": "tw:bg-info",
      "warning": "tw:bg-warning",
      "error": "tw:bg-error",
      "neutral": "tw:bg-inverted"
    },
    "size": {
      "3xs": "tw:h-[4px] tw:min-w-[4px] tw:text-[4px]",
      "2xs": "tw:h-[5px] tw:min-w-[5px] tw:text-[5px]",
      "xs": "tw:h-[6px] tw:min-w-[6px] tw:text-[6px]",
      "sm": "tw:h-[7px] tw:min-w-[7px] tw:text-[7px]",
      "md": "tw:h-[8px] tw:min-w-[8px] tw:text-[8px]",
      "lg": "tw:h-[9px] tw:min-w-[9px] tw:text-[9px]",
      "xl": "tw:h-[10px] tw:min-w-[10px] tw:text-[10px]",
      "2xl": "tw:h-[11px] tw:min-w-[11px] tw:text-[11px]",
      "3xl": "tw:h-[12px] tw:min-w-[12px] tw:text-[12px]"
    },
    "position": {
      "top-right": "tw:top-0 tw:right-0",
      "bottom-right": "tw:bottom-0 tw:right-0",
      "top-left": "tw:top-0 tw:left-0",
      "bottom-left": "tw:bottom-0 tw:left-0"
    },
    "inset": {
      "false": ""
    },
    "standalone": {
      "false": "tw:absolute"
    }
  },
  "compoundVariants": [
    {
      "position": "top-right" as typeof position[number],
      "inset": false,
      "class": "tw:-translate-y-1/2 tw:translate-x-1/2 tw:transform"
    },
    {
      "position": "bottom-right" as typeof position[number],
      "inset": false,
      "class": "tw:translate-y-1/2 tw:translate-x-1/2 tw:transform"
    },
    {
      "position": "top-left" as typeof position[number],
      "inset": false,
      "class": "tw:-translate-y-1/2 tw:-translate-x-1/2 tw:transform"
    },
    {
      "position": "bottom-left" as typeof position[number],
      "inset": false,
      "class": "tw:translate-y-1/2 tw:-translate-x-1/2 tw:transform"
    }
  ],
  "defaultVariants": {
    "size": "md" as typeof size[number],
    "color": "primary" as typeof color[number],
    "position": "top-right" as typeof position[number]
  }
}